export const getLeagueStr = (league, country) => {
  if (country && league.division) {
    const division = (league.division > 1) ? ` D${league.division}` : '';
    return `${country.name}${division}`;
  }
  return league.name;
};

// TODO: find solution for unicode chars
export const slugify = (text) => (
  text.toString().toLowerCase()
    .replace(/\s+/g, '-')          // Replace spaces with -
    .replace(/[^\w\-]+/g, '')      // Remove all non-word chars
    .replace(/\-\-+/g, '-')        // Replace multiple - with single -
    .replace(/^-+/, '')            // Trim - from start of text
    .replace(/-+$/, '')            // Trim - from end of text
);

const toFeet = n => {
  const realFeet = ((n * 0.393700) / 12);
  const feet = Math.floor(realFeet);
  const inches = Math.round((realFeet - feet) * 12);
  return `${feet}'${inches}"`;
};

export const getPlayerHeight = (height) => (
  `${(height/100).toFixed(2)}m / ${toFeet(height)}`
);

export const buildStatsRow = row => {
  row.fg_percent = !row.fg_attempts ? 0 : 100 * row.fg_made / row.fg_attempts;
  row.fg_points = row.p3_made * 3 + row.p2_made * 2;
  row.fg_points_percent = !row.points ? 0 : 100 * row.fg_points / row.points;
  row.p3_percent = !row.p3_attempts ? 0 : 100 * row.p3_made / row.p3_attempts;
  row.p3_points = row.p3_made * 3;
  row.p3_points_percent = !row.points ? 0 : 100 * row.p3_made * 3 / row.points;
  row.p2_percent = !row.p2_attempts ? 0 : 100 * row.p2_made / row.p2_attempts;
  row.p2_points = row.p2_made * 2;
  row.p2_points_percent = !row.points ? 0 : 100 * row.p2_made * 2 / row.points;
  row.ft_points = row.ft_made;
  row.ft_percent = !row.ft_attempts ? 0 : 100 * row.ft_made / row.ft_attempts;
  row.ft_points_percent = !row.points ? 0 : 100 * row.ft_made / row.points;
  row.val = row.points +
    row.fouls_received +
    row.of_rebounds +
    row.df_rebounds +
    row.block_shots +
    row.steals +
    row.assists -
    row.fouls_made -
    row.turnovers -
    row.shots_rejected -
    (row.fg_attempts - row.fg_made) -
    (row.ft_attempts - row.ft_made);
  row.oer = (row.fg_attempts + row.ft_attempts/2 + row.turnovers)
    ? (row.points / (row.fg_attempts + row.ft_attempts/2 + row.turnovers))
    : 0;
  row.vir = !row.minutes ? 0 : (
      (
        (
          (
            row.points +
            row.assists * 1.5 +
            row.steals +
            row.block_shots * 0.75 +
            row.of_rebounds * 1.25 +
            row.df_rebounds * 0.75 +
            row.p3_made / 2 +
            row.fouls_received / 2
          )
          - row.fouls_made / 2
        )
        - (row.fg_attempts - row.fg_made) * 0.75 - row.turnovers
      )
      - (row.ft_attempts - row.ft_made) / 2
    )
    /
    (
      (
        parseInt(row.minutes.split(':')[0], 10) * 60 +
        parseInt(row.minutes.split(':')[1], 10)
      ) / 60
    );
  return row;
};



// WEBPACK FOOTER //
// ./src/utils/utils.js